<template>
<div>
  <div class="copyrightManageBox">
    <Row>
      <Col :span="12">
        <span>ID:</span>
        <span>{{dataList.id}}</span>
      </Col>
      <Col :span="12">
        <span>片名:</span>
        <span>{{dataList.title}}</span>
      </Col>
      <Col :span="12">
        <span>类型:</span>
        <span v-if='dataList.copyrightType=="ip_movie"'>电影</span>
        <span v-if='dataList.copyrightType=="ip_tv"'>电视</span>
        <span v-if='dataList.copyrightType=="ip_variety_show"'>综艺</span>
        <span v-if='dataList.copyrightType=="ip_cartoon"'>动画</span>
        <span v-if='dataList.copyrightType=="ip_vlog"'>短视频</span>
        <span v-if='dataList.copyrightType=="ip_documentary_film"'>纪录片</span>
        <span v-if='dataList.copyrightType=="ip_esports"'>电竞</span>
        <span v-if='dataList.copyrightType=="ip_sports"'>体育</span>
        <span v-if='dataList.copyrightType=="ip_other"'>其他</span>
      </Col>
      <Col :span="12">
        <span>导演:</span>
        <span>{{dataList.director ? dataList.director : '-'}}</span>
      </Col>
      <Col :span="12">
        <span>主演集合:</span>
        <span>{{dataList.mainStar ? dataList.mainStar : "-"}}</span>
      </Col>
      <Col :span="12">
        <span>上映时间:</span>
        <span>{{dataList.releaseDate ? dataList.releaseDate : "-"}}</span>
      </Col>
      <!-- <Col :span="12">
        <span>剧情简介:</span>
        <span>{{dataList.summary}}</span>
      </Col> -->
      <Col :span="12">
        <span>集数:</span>
        <span>{{dataList.episodeNum}}</span>
      </Col>
      <Col :span="12">
        <span>时长:</span>
        <span>{{dataList.duration}}</span>
      </Col>
      <Col :span="12">
        <span>版权授权类型:</span>
        <span v-if='dataList.copyrightAuthType=="ip_auth_exclusive"'>独家</span>
        <span v-if='dataList.copyrightAuthType=="ip_auth_not_exclusive"'>非独</span>
        <span v-if='dataList.copyrightAuthType=="ip_auth_public"'>公版</span>
        <span v-if='dataList.copyrightAuthType=="ip_auth_exclusive_list"'>排他独家</span>
      </Col>
      <Col :span="12">
        <span>是否已转授权运营:</span>
        <span v-if='dataList.copyrightStatus=="1"'>已运营授权</span>
        <span v-if='dataList.copyrightStatus=="0"'>未运营授权</span>
      </Col>
      <Col :span="12">
        <span>版权管理截止时间:</span>
        <span>{{dataList.copyrightEndTime ? dataList.copyrightEndTime : '-'}}</span>
      </Col>
      <Col :span="12">
        <span>昨日收入:</span>
        <span>{{dataList.yesterdayIncome ? dataList.yesterdayIncome : 0}}</span>
      </Col>
      <Col :span="12">
        <span>总收入:</span>
        <span>{{dataList.totalIncome ? dataList.totalIncome : 0}}</span>
      </Col>
      <Col :span="12">
        <span>管理时间:</span>
        <span>{{dataList.copyrightStartTime ? dataList.copyrightStartTime : '-'}}</span>
      </Col>
      <Col :span="12">
        <span>所属版权方:</span>
        <span>{{dataList.copyrightVendorName}}</span>
      </Col>
      <Col :span="12">
        <span>自媒体运营家数:</span>
        <span>{{dataList.operateWemediaNo}}</span>
      </Col>
    </Row>
  </div>
  <div class="copyrightManageBox" style='padding:16px'>
      <Row @keydown.enter.native="handleSearch" style="margin-top:5px;padding-top:20px">
        <Form id="search-form-y" ref="searchForm" :model="searchForm" inline :label-width="100" class="search-form">
          <Form-item label="平台" prop="mediaPlatform">
            <Input type="text" v-model="searchForm.mediaPlatform" placeholder="请输入发布平台" clearable style="width: 200px"/>
          </Form-item>
          <Button style="margin-left:20px;" @click="handleSearch" type="primary" icon="ios-search">搜索</Button>
        </Form>
      </Row>
      <Row>
        <Table :loading="loading" border :columns="columns" :data="data" ref="table" sortable="custom" @on-sort-change="changeSort" @on-selection-change="changeSelect"></Table>
      </Row>
      <Row type="flex" justify="end" class="page" style="margin-top:20px">
        <Page :current="searchForm.pageNumber" :total="total" :page-size="searchForm.pageSize" @on-change="changePage" @on-page-size-change="changePageSize" :page-size-opts="[10,20,50]" size="small" show-total show-elevator show-sizer></Page>
      </Row>
    </div>
</div>
</template>

<script>

import {copyrightManageDetail} from "@/api/index";
export default {
  name: "copyright_manage_detail",
  components: {
  },
  data() {
    return {
      dataList:[],
      loading: true, // 表单加载状态
      searchForm:{
        copyrightName:this.$route.query.name,
        pageNumber: 1, // 当前页数
        pageSize: 10, // 页面大小
        sort: "create_time", // 默认排序字段
        order: "desc", // 默认排序方式
        copyrightType:'版权方统计分析账号2',
      },
      columns: [
        {
          type: "index",
          width: 60,
          align: "center"
        },
        {
          title: "标题",
          key: "title",
          minWidth: 120,
          sortable: false,
          render: (h, params) => {
            return h("div", [
              h("a",
                {
                  on: {
                    click: () => {
                      this.goUrl(params.row.linkUrl);
                    }
                  }
                },
                params.row.title
              )
            ])
          }
        },
        {
          title: "发布平台",
          key: "mediaPlatform",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "自媒体账号",
          key: "wemediaAccountCode",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "播放量",
          key: "playCount",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "版权名",
          key: "copyrightName",
          minWidth: 120,
          sortable: false,
        },
      ],
      data: [], // 表单数据
      total: 0 ,// 表单数据总数
      copyrightVendorNameD:'版权方统计分析账号2',
      copyrightNameD:'哪吒降魔',
    };
  },
  watch: {
    // 监听路由变化
    $route(to, from) {
      if (to.name == "copyright_manage_detail") {
        this.init();
      }
    }
  },
  methods: {
    init() {
      this.getDataList();
      this.getDataListTable();
    },
    goUrl(url){
      window.open(url,'_blank')
    },
    changePage(v) {
      this.searchForm.pageNumber = v;
      this.getDataListTable();
      this.clearSelectAll();
    },
    changePageSize(v) {
      this.searchForm.pageSize = v;
      this.getDataListTable();
    },
    //获取详情页详细信息
    getDataList() {
      this.loading = true;
     copyrightManageDetail(this.$route.query.id).then(res => {
       console.log(res)
       if(res.success){
         this.dataList = res.result
       }
     })
      this.loading = false;
    },
    copyTypeChange(v){
      this.copyrightVendorNameD = v.value
      this.copyrightNameD = v.label
    },
    handleSearch() {
      this.searchForm.pageNumber = 1;
      this.searchForm.pageSize = 10;
      this.getDataListTable();
    },
    getDataListTable() {
      this.loading = true;
      console.log(this.searchForm);
      // 带多条件搜索参数获取表单数据 请自行修改接口
      this.getRequest("/incomeAnalyse/getByPage", this.searchForm).then(res => {
        this.loading = false;
        if (res.success) {
          this.data = res.result.records;
          this.total = res.result.total;
        }
      });
      this.total = this.data.length;
      this.loading = false;
    },
  },
  mounted() {
    this.init();
  }
};
</script>
<style lang="less">
    .copyrightManageBox{
      background: #fff;
    border-radius: 4px;
    margin-bottom: 5px;
        .ivu-row{
            line-height: 40px;
            .ivu-col{
                span:nth-of-type(1){
                    width: 115px;
                    display: inline-block;
                    text-align: right;
                }
                span:nth-of-type(2){
                    margin-left:15px;
                }
            }
        }
    }

</style>